/* 
import cart from '@/constants/cart'
*/

let cart={
    platform:{
        mac:'1',
        win:'2',
        ios:'3',
        android:'4',
        other:'5',
    },
    host:[
        {
            host:'1',
            __ZH:'Eng-英语',
            lang:'en',
        },
        {
            host:'2',
            __ZH:'Deu-德语',
            lang:'de',
        },
        {
            host:'3',
            __ZH:'Espa-西语',
            lang:'es',
        },
        {
            host:'4',
            __ZH:'Fran-法语',
            lang:'fr',
        },
        {
            host:'5',
            __ZH:'ltal-意大利语',
            lang:'it',
        },

        {
            host:'6',
            __ZH:'Port-葡语',
            lang:'',
        },
        {
            host:'7',
            __ZH:'Japan-日语',
            lang:'jp',
        },
        {
            host:'8',
            __ZH:'Kore-韩语',
            lang:'kr',
        },
        {
            host:'9',
            __ZH:'Arab-阿语',
            lang:'ar',
        },
        {
            host:'10',
            __ZH:'Nede-荷兰语',
            lang:'nl',
        },

        {
            host:'11',
            __ZH:'Indo-印尼语',
            lang:'inn',
        },
        {
            host:'12',
            __ZH:'India-印度语',
            lang:'id',
        },
        {
            host:'13',
            __ZH:'Turk-土耳其语',
            lang:'tr',
        },
        {
            host:'14',
            __ZH:'Russ-俄语',
            lang:'ru',
        },
        {
            host:'15',
            __ZH:'Tail-泰语',
            lang:'',
        },

        {
            host:'16',
            __ZH:'TChi-中繁',
            lang:'tw',
        },
        {
            host:'17',
            __ZH:'SChi-中简',
            lang:'cn',
        },
    ],
    func:[
        {
            func:'18',
            __ZH:'动态老照片',
            work:'dynamic-photo',
        },
        {
            func:'19',
            __ZH:'动态人脸',
            work:'add-lip-shape',
        },
        {
            func:'20',
            __ZH:'音频提取',
            work:'audio-extractor',
        },
        {
            func:'21',
            __ZH:'音频裁剪',
            work:'audio-cut',
        },
        {
            func:'22',
            __ZH:'视频转动图',
            work:'to-gif',
        },

        {
            func:'23',
            __ZH:'视频格式转换',
            work:'convert-video',
        },
        {
            func:'24',
            __ZH:'图片格式转换',
            work:'convert-image',
        },
        {
            func:'25',
            __ZH:'音频合并',
            work:'audio-joiner',
        },
        {
            func:'26',
            __ZH:'视频压缩',
            work:'video-compress',
        },
        {
            func:'27',
            __ZH:'音频格式转换',
            work:'convert-audio',
        },

        {
            func:'28',
            __ZH:'音频添加背景音乐',
            work:'audio-add-music',
        },
        {
            func:'29',
            __ZH:'音频压缩',
            work:'audio-compress',
        },
        {
            func:'30',
            __ZH:'视频静音',
            work:'video-mute',
        },
        {
            func:'31',
            __ZH:'音频调整音量',
            work:'audio-volume',
        },
        {
            func:'32',
            __ZH:'音频变速',
            work:'audio-speed',
        },

        {
            func:'33',
            __ZH:'录屏',
            work:'screen-recorder',
        },
        {
            func:'34',
            __ZH:'抠图（changer）',
            work:'image-bg-changer',
        },
    ],

}


export default cart